import { Typography, Stack } from '@mui/material'
import theme from 'theme'
import TrendingUpRoundedIcon from '@mui/icons-material/TrendingUpRounded'
import TrendingDownRoundedIcon from '@mui/icons-material/TrendingDownRounded'
import TrendingFlatRoundedIcon from '@mui/icons-material/TrendingFlatRounded'

const iconStyles = {
  color: theme.vars.palette.text.primary,
  background: theme.vars.palette.background.secondary,
  borderRadius: '0.4rem',
  padding: '0.2rem',
}

const TableTrend = ({ value = '88', trend = '+2.22%' }) => {
  const isPositive = parseFloat(trend) > 0
  const isZero = parseFloat(trend) === 0

  return (
    <Stack direction="row" alignItems="center">
      <Typography variant="percent" sx={{ mr: '0.8rem' }}>
        {value}
      </Typography>

      {isZero ? (
        <TrendingFlatRoundedIcon fontSize="small" sx={iconStyles} />
      ) : isPositive ? (
        <TrendingUpRoundedIcon fontSize="small" sx={iconStyles} />
      ) : (
        <TrendingDownRoundedIcon fontSize="small" sx={iconStyles} />
      )}

      {trend ? (
        <Typography variant="caption" sx={{ opacity: 0.6, ml: '0.6rem' }}>
          {trend}
        </Typography>
      ) : null}
    </Stack>
  )
}

export default TableTrend
